import React, { useState } from "react";

import { ImLinkedin2 } from "@react-icons/all-files/im/ImLinkedin2";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { AiOutlineGithub } from "@react-icons/all-files/ai/AiOutlineGithub";
import { FaBehance } from "@react-icons/all-files/fa/FaBehance";
import { MdKeyboardArrowUp } from "@react-icons/all-files/md/MdKeyboardArrowUp";

function Footer() {
  function handleclick() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  const [activebtn, setactivebtn] = useState(false);
  function handleClick2() {
    window.scrollTo({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
    setactivebtn(true);
    setTimeout(() => {
      setactivebtn(false);
    }, 1000);
  }
  return (
    <div>
      <div className=" pointer-events-none purple-full-width z-10 bg-gradient-to-t from-primary to-secondary/0 bottom-0 w-full h-[100vh] " />
      <div className="z-20 relative full-width bg-primary">
        <div className="max-w-[1550px] px-6 md:px-8  relative m-auto ">
          <div className="hidden md:block m-auto md:max-w-[1550px] px-0 md:px-[15px] lg:px-8 cursor-pointer relative">
            <div
              onClick={handleclick}
              className="h-[72px] w-[72px] -translate-y-[50%] absolute  bg-tertiary hover:bg-tertiary/90 duration-500 ease-in-out flex justify-center items-center text-[38px] right-0"
            >
              <MdKeyboardArrowUp />
            </div>
          </div>
          <div className="purple-full-width"></div>
          <div className="py-20 overflow-hidden">
            <div className="grid gap-y-14 lg:gap-y-0 grid-col-1 text-center lg:text-left lg:justify-start lg:grid-cols-4 gap-x-4 ">
              <div className=" col-span-1 lg:col-span-2">
                <span className="text-[14px] md:text-[16px] font-SoraR text-tertiary uppercase">
                  did you like my work?
                </span>
                <h1 className=" font-SoraB mt-2 pb-4 sm:pb-2 leading-[1.05] text-[32px] md:text-[40px] lg:text-[48px]  text-tertiary uppercase">
                  LET'S BECOME CONNECTED
                </h1>
                <div className="mt-4 lg:mt-8  flex flex-col gap-y-4 md:gap-y-0 items-center md:flex-row  justify-center lg:justify-start gap-x-8 2xl:items-center uppercase">
                  <div
                    onClick={handleClick2}
                    className="flex z-50  justify-center items-center font-SoraB uppercase cursor-pointer text-secondary h-[52px] max-w-full w-full md:w-[280px] bg-tertiary hover:bg-tertiary/90 duration-500 ease-in-out relative "
                  >
                    <button className="uppercase z-50">Follow me</button>
                    <div className="hidden lg:block rounded-full w-6 h-6 scale-100 hover:scale-110 duration-500 ease-in-out bg-primary border-2  border-secondary z-50 absolute -bottom-[12px]" />
                    <div className="hidden lg:block h-[100vh] pointer-events-none  absolute w-[110px] bg-primary bottom-0  translate-y-full "></div>
                    <div className="hidden lg:block h-[100vh] absolute w-[2px] bg-secondary bottom-0 translate-y-full "></div>
                  </div>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://giphy.com/gifs/thank-you-christian-bale-9yGa9mD2gyUnu/fullscreen"
                    className="flex golden-btn-effect  justify-center items-center font-SoraB gap-x-4 uppercase max-w-full w-full md:w-[280px] cursor-pointer text-secondary h-[52px] px-4 bg-yellow-500 relative"
                  >
                    <img
                      className="object-cover"
                      width="20"
                      height="24"
                      loading="lazy"
                      src={`https://img.gs/bfcwxjcwhk/full,quality=medium/https://eyenovel.netlify.app/icon/icon.png`}
                      alt="coffe"
                    />
                    <button className="uppercase">buy me a coffe</button>
                  </a>
                </div>
              </div>
              <div className="flex  col-span-1 lg:col-span-2 flex-col gap-y-4 lg:justify-end justify-center items-center  lg:items-end">
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://wa.me/212614200216"
                >
                  <div className=" flex  flex-col gap-y-2 w-fit relative group cursor-pointer">
                    <div>
                      <h2 className="text-[25px] md:text-[32px] font-SoraR text-tertiary">
                        +212 614200216
                      </h2>
                      <div className="w-[80%]  left-1/2 -translate-x-1/2 lg:-translate-x-full lg:left-full group-hover:w-[100%] duration-500 ease-in-out absolute bg-tertiary h-[1px]"></div>
                    </div>
                    <div>
                      <h3 className="uppercase text-[13px] md:text-[16px]  float-none lg:float-right font-SoraL text-tertiary">
                        Whatssap
                      </h3>
                    </div>
                  </div>
                </a>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.osama-daimallah.com/"
                >
                  <div className="flex flex-col gap-y-2 w-fit relative group cursor-pointer">
                    <div>
                      <h2 className="text-[25px] md:text-[32px] text-center md:text-right uppercase font-SoraR text-tertiary">
                        osama-daimallah.com
                      </h2>
                      <div className="w-[80%] left-1/2 -translate-x-1/2 lg:-translate-x-full lg:left-full group-hover:w-[100%] duration-500 ease-in-out absolute bg-tertiary h-[1px]"></div>
                    </div>
                    <div>
                      <h3 className="uppercase text-[14px] md:text-[16px] float-none lg:float-right font-SoraL text-tertiary">
                        Website
                      </h3>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className=" w-full h-[1px] bg-tertiary mt-20 lg:mt-28 mb-14"></div>
            <div className="text-center flex justify-center items-center">
              <div className="flex flex-wrap w-fit z-10 relative justify-center items-center gap-y-4 gap-x-4 md:gap-x-8">
                <div className="hidden md:block bg-tertiary  -z-10 absolute w-full h-[1px]"></div>
                <a
                  aria-label="linkedin"
                  href="https://www.linkedin.com/in/osama-daimallah/"
                  rel="noreferrer"
                  target="_blank"
                  className={
                    activebtn
                      ? "cursor-pointer relative bg-tertiary text-primary duration-500 ease-in-out w-[52px] h-[52px]  border-[1px] border-tertiary flex justify-center items-center text-[22px] "
                      : "cursor-pointer relative bg-primary hover:bg-tertiary hover:text-primary duration-500 ease-in-out w-[52px] h-[52px]  border-[1px] border-tertiary flex justify-center items-center text-[22px] text-tertiary"
                  }
                >
                  <ImLinkedin2 />
                  <div className="rounded-full w-6 h-6 bg-primary scale-100 hover:scale-110 duration-500 ease-in-out border-2  z-50 border-secondary absolute -bottom-[12px]" />
                  <div className="h-[100vh]  overflow-hidden  absolute w-[2px] bg-secondary bottom-0 translate-y-full " />
                </a>
                <a
                  aria-label="twitter"
                  href="https://twitter.com/OsamaDaimallah"
                  rel="noreferrer"
                  target="_blank"
                  className={
                    activebtn
                      ? "cursor-pointer relative bg-tertiary text-primary duration-500 ease-in-out w-[52px] h-[52px]  border-[1px] border-tertiary flex justify-center items-center text-[22px] "
                      : "cursor-pointer relative bg-primary hover:bg-tertiary hover:text-primary duration-500 ease-in-out w-[52px] h-[52px]  border-[1px] border-tertiary flex justify-center items-center text-[22px] text-tertiary"
                  }
                >
                  <FaTwitter />
                </a>
                <a
                  aria-label="github"
                  href="https://github.com/Osama-D"
                  rel="noreferrer"
                  target="_blank"
                  className={
                    activebtn
                      ? "cursor-pointer relative bg-tertiary text-primary duration-500 ease-in-out w-[52px] h-[52px]  border-[1px] border-tertiary flex justify-center items-center text-[25px] "
                      : "cursor-pointer relative bg-primary hover:bg-tertiary hover:text-primary duration-500 ease-in-out w-[52px] h-[52px]  border-[1px] border-tertiary flex justify-center items-center text-[25px] text-tertiary"
                  }
                >
                  <AiOutlineGithub />
                </a>
                <a
                  aria-label="behance"
                  href="https://www.behance.net/OsamaDaimallah"
                  rel="noreferrer"
                  target="_blank"
                  className={
                    activebtn
                      ? "cursor-pointer relative bg-tertiary text-primary duration-500 ease-in-out w-[52px] h-[52px]  border-[1px] border-tertiary flex justify-center items-center text-[22px] "
                      : "cursor-pointer relative bg-primary hover:bg-tertiary hover:text-primary duration-500 ease-in-out w-[52px] h-[52px]  border-[1px] border-tertiary flex justify-center items-center text-[22px] text-tertiary"
                  }
                >
                  <FaBehance />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
